/**
 * Cliente HTTP da API da Loja (violaocatolico-loja-api).
 * Independente da paymentService.js, que aponta para a cantate-api.
 */

const API_BASE_URL =
  (typeof window !== 'undefined' && window.__REACT_APP_LOJA_API_URL) ||
  process.env.REACT_APP_LOJA_API_URL ||
  'http://localhost:4001';

async function request(path, { method = 'GET', body, token } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(data?.error || `Erro HTTP ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return data;
}

export const authService = {
  register: ({ name, email, password, cpf, whatsapp, signupOrigin }) =>
    request('/api/auth/register', { method: 'POST', body: { name, email, password, cpf, whatsapp, signupOrigin } }),

  login: ({ email, password }) =>
    request('/api/auth/login', { method: 'POST', body: { email, password } }),

  me: (token) => request('/api/auth/me', { token }),

  updateWhatsapp: (token, whatsapp) =>
    request('/api/auth/whatsapp', { method: 'POST', token, body: { whatsapp } }),

  forgotPassword: (email) =>
    request('/api/auth/forgot-password', { method: 'POST', body: { email } }),

  resetPassword: (email, resetCode, newPassword) =>
    request('/api/auth/reset-password', { method: 'POST', body: { email, resetCode, newPassword } }),
};
